module.exports = __webpack_public_path__ + "static/media/Keyframe_Cursor-01_Near.29f42bff.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Features/TelestrationsVideoLibrary/Assets/svg/Keyframe_Cursor-01_Near.svg
// module id = 7402
// module chunks = 0